import Cookie from "js-cookie";
import initPopup from "./popup";
import DrForm from './dr-form'
import FormPreFill from './form-pre-fill'
import FormValidation from './form-validation'
import FormCaptcha from './form-captcha'
import FormAnalytics from "./form-analytics"
import UtmGenerator from "../utm_generator/utm_generator";
import {setLocalStorageInfo} from "./pre-fill/local-storage";

class Form {
	constructor() {
		initPopup();
		if (typeof wFORMS !== 'undefined') {
			this.initForms();
		}
		// Useful FormAssembly functions:
		// 1. Get instance of behaviour for a form:
		// wFORMS.getBehaviorInstance(document.querySelector('.dr-form form'), "validation")
	}

	initForms() {
		// Setup forms on page
		document.querySelectorAll('.dr-form:not(.dr-loaded)').forEach((drForm) => {
			if (drForm.querySelector('form')) {
				new DrForm(drForm);
                this.addHiddenFields(drForm.querySelector('form'));
				new FormPreFill(drForm);
				new FormValidation(drForm);
				FormAnalytics.init(drForm);
				drForm.classList.add('dr-loaded');
			}
		});
		// Set global callback to apply actions we need to do before form submit
		wFORMS.behaviors.validation.onPass = this.beforeSubmit.bind(this);
	}

	async beforeSubmit(wFORMSInstance, e) {
		let form = e.target;
		let drForm = form.closest('.dr-form');
		this.showFormLoader(form);
		FormCaptcha.maybeInit(drForm, e);
		if (!FormCaptcha.isNeeded || (FormCaptcha.isNeeded && FormCaptcha.isPassed)) {
            setLocalStorageInfo(drForm);
			this.triggerEvent('dr.form-success', form);
			FormAnalytics.onFormSuccess(drForm);
			this.setWebinarCookies();
		}
        await new Promise(r => setTimeout(r, 2000));

		return false;
	}

	showFormLoader(form) {
		jQuery(form).find('.dr-loader').fadeIn(150);
	}

	addHiddenFields(form) {
		let formShell = form.closest('.dr-form');
		let hiddenFields = {
			"redirect": formShell.dataset['redirect'] || '',
			"isWebinarForm": formShell.dataset['iswebinarform'] || 0,
			"isSalesForm": formShell.dataset['issalesform'] || 0,
			"Description": formShell.dataset['formdescription'] || '',
			"Form_Category__c": Form.getFormCategory(formShell),
			"Website__c": formShell.dataset['companywebsite'] || '',
			"Campaign_Name_Id__c": formShell.dataset['campaignnameid'] || '',
			"Campaign_Name__c": UtmGenerator.getUtmValue('campaign'),
			"Campaign_Source__c": UtmGenerator.getUtmValue('source'),
			"Campaign_Medium__c": UtmGenerator.getUtmValue('medium'),
			"Campaign_Content__c": UtmGenerator.getUtmValue('content'),
			"Campaign_Term__c": UtmGenerator.getUtmValue('term'),
			"Gclid__c": UtmGenerator.getUtmValue('gclid'),
			"Licid__c": UtmGenerator.getUtmValue('licid'),
			"Fbaid__c": UtmGenerator.getUtmValue('fbaid'),
			"CTA_Id__c": UtmGenerator.getCtaValue('id'),
			"CTA_Name__c": UtmGenerator.getCtaValue('name'),
			"CTA_Position__c": UtmGenerator.getCtaValue('position'),
			"CTA_Creative__c": UtmGenerator.getCtaValue('creative'),
		};
		for (let name in hiddenFields) {
			form.append(this.createHiddenInput(name, hiddenFields[name]));
		}
	}

	// Additional functions
	static getFormCategory(formShell) {
		let formCategory = formShell.dataset['category'] || '';
		if (formCategory.toLowerCase() === 'request a demo') {
			formCategory = 'Request a demo';
		}
		return formCategory;
	}

	setWebinarCookies() {
		// Set cookie if Webinar form was submitted
		let webinarId = document.querySelector('body').dataset.webinarId;
		if (webinarId) {
			let webinarIds = Cookie.get('STYXKEY-watch-webinars');
			webinarIds = webinarIds ? webinarIds.split(',') : [];
			if (webinarIds.indexOf(webinarId) === -1) {
				webinarIds.push(webinarId);
				Cookie.set('STYXKEY-watch-webinars', webinarIds.join(','));
			}
		}
	}

	// Helpers
	triggerEvent(name, form) {
		let event = new Event(name, {'bubbles': true});
		form.dispatchEvent(event);
	}

	createHiddenInput(name, value) {
		let node = document.createElement('input');
		node.type = 'hidden';
		node.name = name;
		node.value = value;
		return node;
	}
}

export const getFormCategory = Form.getFormCategory;
export default Form
